module.exports = __webpack_public_path__ + "static/img/vip_ico(2).0c1f594e.png";